
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    description: {
      type: Object,
      required: false,
    },
    questions: {
      type: Object,
      required: false,
    },
  },
  computed: {
    jsonld() {
      let mainEntity = this.questions.map((question) => {
        let answer = this.$md.render(question.answer)

        if (answer.endsWith('\n')) {
          answer = answer.substring(0, answer.length - 1)
        }

        return {
          '@type': 'Question',
          name: question.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: answer,
          },
        }
      })

      return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: mainEntity,
      }
    },
  },
}
